import ThemesService from '@/services/codebooks/ThemesService'

export default {
  namespaced: true,
  state: {
    themesList: []
  },
  getters: {
    themesList: state => state.themesList
  },
  actions: {
    refreshThemes ({ commit }) {
      return ThemesService.getAllThemes()
        .then(list => {
          commit('SET_THEMES', list)
        })
    },
    addNewTheme ({ commit }, theme) {
      return ThemesService.saveTheme(theme).then(result => {
        theme.id = result.data
        commit('ADD_THEME', theme)
        return theme
      })
    },
    editTheme ({ commit }, theme) {
      return ThemesService.saveTheme(theme).then(result => {
        commit('EDIT_THEME', theme)
        return theme
      })
    },
    deleteTheme ({ commit }, theme) {
      return ThemesService.removeTheme(theme).then(result => {
        commit('DELETE_THEME', theme)
      })
    }
  },
  mutations: {
    SET_THEMES (state, list) {
      state.themesList = list
    },
    EDIT_THEME (state, theme) {
      const current = state.themesList[theme.index]
      current.name = theme.name
    },
    ADD_THEME (state, theme) {
      const newTheme = {
        id: theme.id,
        name: theme.name
      }
      state.themesList.push(newTheme)
    },
    DELETE_THEME (state, theme) {
      state.themesList.splice(theme.index, 1)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/codebook/themes.js